<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/table';
export default {
  name: 'ecom-sys-platformOrderLog',
  components: {
    PageTable,
  },
}
</script>